module.exports = __webpack_public_path__ + "img/Unidad22-5.8fb82301.png";